<template>
  <div>
    <MovieList :movies="dorms" v-if="dorms"/>
    <FixedPopup :dorms="popupDorms" v-if="popupDorms && popupDorms.length > 0"/>
  </div>
</template>

<script>
import MovieList from '@/components/MovieList'
import FixedPopup from '@/components/FixedPopup'
import axios from 'axios'

export default {
  name: 'BranchDistrict',
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.district ? this.district.title : '',
      meta: [
        { vmid: 'description', name: 'description', content: this.district ? this.district.description : '' },
        { vmid: 'keywords', name: 'keywords', content: this.district ? this.district.keywords : '' }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: this.url }
      ]
    }
  },
  components: {
    MovieList,
    FixedPopup
  },
  data () {
    return {
      dorms: [],
      popupDorms: null,
      errors: [],
      district: {
          title: ''
      },
      url: ''
    }
  },
  methods: {
  getDorms() {
    const id = window.localStorage.getItem('branchedDormId')
    const district = window.localStorage.getItem('district')
    var self = this
        // const url = self.$attrs.redirect ? `/site/dorm/detail/old/${dormID}` : `/site/dorm/detail/${this.$route.params.id}`
       const url = `/site/dorm/branches/${id}`
       axios.get(url)
         .then(response => {
           // this.isLoading = false
           // self.detail = response.data
           self.dorms = []
           if(response.data.branches) {
             window.localStorage.setItem('branchnumber', response.data.branches.length)  
             response.data.branches.forEach(item => {
                    if(item.district.name === district) {
                self.dorms.push(item)
                    }
              }) 
             self.allDorms = response.data.branches
           }        
    })
  },
  },
  created () {
    this.getDorms()
    this.url = window.location.origin + '/' + this.$route.params.city + '-movies/'
  },
  watch: {
    $route () {
      this.getDorms()
      this.district.title = window.localStorage.getItem('district')
    }
  }
}
</script>

<style lang="scss">
</style>
